module.exports = __webpack_public_path__ + "templates/about-contact.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/about/templates/about-contact.html
// module id = mZpu
// module chunks = 1